import React, { Component } from "react";
import _ from "lodash";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import { withStyles } from "@material-ui/core/styles";
import StatusCard from "../../granular/Leftpanel/statuscard";
import ReportingTable from "../../granular/Leftpanel/reportingTable";
import OnoffhireTable from "../../granular/Leftpanel/onoffhiretable";
import StatisticCard from "../../granular/Leftpanel/statisticCard";
import { pushLoader } from "../../actions/main";
import { connect } from "react-redux";

import {
  fetchPtmGpsapirtSearchStatus,
  fetchInactive,
  fetchTrackSpeed
} from "../../api/portal";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  },
  container: {
    padding: "0px 5vw 0px 5vw"
  },
  info: {
    padding: "50px 0px 60px 0px",
    width: "100%"
  }
});
export class Reporting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onhire: 0,
      offhire: 0,
      speed: 0,
      inactive: 0,
      datainactive: [],
      dataonhire: [],
      dataoffhire: [],
      loader1: null,
      loader2: null
    };
  }

  componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader1: true, loader2: true });
    fetchPtmGpsapirtSearchStatus("on hire")
      .then(response => {
        if (response != null) {
          let sortdata = _.orderBy(
            response.data.results,
            "date_created",
            "desc"
          );
          this.setState({
            onhire: response.data.count,
            dataonhire: sortdata
          });
        }
        this.props.pushLoader(false);
        this.setState({ loader1: false });
      })
      .catch(error => {
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
    this.props.pushLoader(true);
    fetchPtmGpsapirtSearchStatus("off hire")
      .then(response => {
        if (response != null) {
          let sortdata = _.orderBy(
            response.data.results,
            "date_created",
            "desc"
          );
          this.setState({
            offhire: response.data.count,
            dataoffhire: sortdata
          });
        }
        this.props.pushLoader(false);
        this.setState({ loader2: false });
      })
      .catch(error => {
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
    this.props.pushLoader(true);
    fetchInactive("1", "1", "GPS")
      .then(response => {
        if (response != null) {
          console.log(response.data.results);
          let sortdata = _.orderBy(
            response.data.results,
            "dateCreated",
            "desc"
          );
          this.setState({
            inactive: response.data.results.length,
            datainactive: sortdata
          });
        }
        this.props.pushLoader(false);
        this.setState({ loader1: false });
      })
      .catch(error => {
        // this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
    this.props.pushLoader(true);
    fetchTrackSpeed("0", "30")
      .then(response => {
        if (response != null) {
          console.log(response.data.results);
          let sortdata = _.orderBy(
            response.data.results,
            "dateCreated",
            "desc"
          );
          this.setState({
            speed: response.data.results.length,
            dataspeed: sortdata
          });
        }
        this.props.pushLoader(false);
        this.setState({ loader2: false });
      })
      .catch(error => {
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ justifyContent: "center", marginBottom: "100px" }}>
              <Typography className={classes.title}>Reporting</Typography>
              <CustomLinearProgress
                variant="determinate"
                color="gray"
                value={0}
                style={{ width: "40%", display: "inline-block" }}
              />
              <CustomLinearProgress
                variant="determinate"
                color="info"
                value={100}
                style={{ width: "20%", display: "inline-block" }}
              />
              <CustomLinearProgress
                variant="determinate"
                color="gray"
                value={0}
                style={{ width: "40%", display: "inline-block" }}
              />
            </div>
          </GridItem>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid container justify="center" spacing={6}>
                <StatusCard
                  option={1}
                  title="On Hire"
                  total={this.state.onhire}
                />
                <StatusCard
                  option={2}
                  title="Off Hire"
                  total={this.state.offhire}
                />
                <StatusCard
                  option={3}
                  title="Inactive"
                  total={this.state.inactive}
                />
                <StatusCard
                  option={3}
                  title="Speed Alert"
                  total={this.state.speed}
                />
              </Grid>
              <div className={classes.info}>
                <OnoffhireTable
                  dataonhire={this.state.dataonhire}
                  dataoffhire={this.state.dataoffhire}
                  loader1={this.state.loader1}
                  loader2={this.state.loader2}
                />
              </div>
              <div className={classes.info}>
                <ReportingTable
                  datainactive={this.state.datainactive}
                  dataspeed={this.state.dataspeed}
                  loader1={this.state.loader1}
                  loader2={this.state.loader2}
                />
              </div>
              {/* <Grid container justify="center" spacing={3}>
                <StatisticCard
                  option={1}
                  title="Zone Tracking"
                  chartType="line"
                  chartBgColor="#0eb5cb"
                  chartColor="#FFFFFF"
                />
                <StatisticCard
                  option={2}
                  title="Inactive Vessel Type"
                  chartType="column"
                  chartBgColor="#fd950e"
                  chartColor="#FFFFFF"
                />
                <StatisticCard
                  option={3}
                  title="Approach Vessel"
                  chartType="line"
                  chartBgColor="#e63d36"
                  chartColor="#FFFFFF"
                />
              </Grid> */}
            </Grid>
          </Grid>
        </GridContainer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(
  mapStateToProps,
  { pushLoader }
)(withStyles(styles)(Reporting)));
